import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from "./FacilityList.module.css";
import { useTranslation } from "react-i18next";
import SafeText from "./SafeText";
import BookmarkButton from "./BookmarkButton";
import GoogleMapButton from "./GoogleMapButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneSquare, faGlobeAsia } from "@fortawesome/free-solid-svg-icons";

const FacilityList = ({
  filteredFacilities,
  handleBookmark,
  bookmarkedFacilities,
}) => {
  const { t } = useTranslation();

  const [displayFacilities, setDisplayFacilities] = useState([]);
  const [loadedCount, setLoadedCount] = useState(0);
  const itemsPerPage = 20;
  const observer = useRef();

  const loadMoreItems = useCallback(() => {
    const nextItems = filteredFacilities.slice(loadedCount, loadedCount + itemsPerPage);
    setDisplayFacilities(prevItems => [...prevItems, ...nextItems]);
    setLoadedCount(prevCount => prevCount + itemsPerPage);
  }, [filteredFacilities, loadedCount]);

  const lastItemRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && loadedCount < filteredFacilities.length) {
        loadMoreItems();
      }
    });
    if (node) observer.current.observe(node);
  }, [loadMoreItems, loadedCount, filteredFacilities.length]);

  // filteredFacilitiesが更新されたら、loadedCountを0にリセットし、
  // displayFacilitiesを空にする
  useEffect(() => {
    setLoadedCount(0);
    setDisplayFacilities([]);
  }, [filteredFacilities]);

  return (
    <div className={styles.container}>
      {displayFacilities.map((facility) => (
        <div className={styles.wrapper} key={facility.id}>
          <div className={styles.course}>
            {facility.type1 !== "" ? (
              <div className={`${styles.badge01} ${styles.badge}`}>
                <span>{facility.type1}</span>
              </div>
            ) : (
              ""
            )}
            {facility.type2 !== "" ? (
              <div className={`${styles.badge02} ${styles.badge}`}>
                <span>{facility.type2}</span>
              </div>
            ) : (
              ""
            )}
            {facility.type3 !== "" ? (
              <div className={`${styles.badge03} ${styles.badge}`}>
                <span>{facility.type3}</span>
              </div>
            ) : (
              ""
            )}
            {facility.type4 !== "" ? (
              <div className={`${styles.badge04} ${styles.badge}`}>
                <span>{facility.type4}</span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className={styles.name}>
            {facility.name}
            <BookmarkButton
              facilityId={facility.id}
              handleBookmark={handleBookmark}
              bookmarkedFacilities={bookmarkedFacilities}
            />
          </div>
          <div className={styles.address}>
            <SafeText text={facility.address} />
            <GoogleMapButton
              facilityAddress={facility.address}
              facilityName={facility.name}
            />
            <div className={styles.tel}><span className={styles.icon}><FontAwesomeIcon icon={faPhoneSquare} /></span><SafeText text={facility.tel} /></div>
            <div className={styles.url}><span className={styles.icon}><FontAwesomeIcon icon={faGlobeAsia} /></span><a href={facility.link} target="hospital">{facility.link}</a></div>
          </div>
          <div className={styles.options}>
            <div>
                <SafeText text={t("子宮")} />
              </div>
              <div>
              { facility.sikyu  ? <SafeText text={facility.sikyu} /> : <span>―</span> }
              </div>
              <div>
                <SafeText text={t("マンモ")} />
              </div>
              <div>
                { facility.manmo  ? <SafeText text={facility.manmo} /> : <span>―</span> }
              </div>
              <div>
                <SafeText text={t("エコー")} />
              </div>
              <div>
                { facility.echo  ? <SafeText text={facility.echo} /> : <span>―</span> }
              </div>
          </div>
          { facility.bikou && (<div className={styles.memo}><SafeText text={facility.bikou} /></div>)}
        </div>
      ))}
      {loadedCount < filteredFacilities.length && (
        <div ref={lastItemRef} style={{ height: 20, background: 'transparent' }}></div>
      )}
    </div>
  );
};

export default FacilityList;
